import React from 'react';
import {Col, Image, Row} from 'react-bootstrap';

class CanvasPages extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        
    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(prev_props, prev_state) {
        if(prev_props.pages == 0 && this.props.pages != 0){
            //this code should run only at the start
            var doms = [];
            // if(this.props.role =='view'){
            //     for (var i = 0; i < this.props.pages; i++) {
            //         doms.push(window.document.createElement('div'));
            //     }
            // }else{
                for (var i = 0; i < this.props.pages; i++) {
                    doms.push(window.document.getElementById('design_preview'+i))
                }
            // }

            var url_params = new URLSearchParams(window.location.search);
            var category_id = url_params.get('category');
            var input_feed
            if(this.props.thumbnail){
                input_feed = {...this.props.design_file,thumbnail:this.props.thumbnail}
            }else{
                input_feed = this.props.design_file
            }

            var dont_activate_controller = false;
            if(this.props.role == 'view'){
                dont_activate_controller = true;
            }

            window.design_editor = new window.DM_Editor(input_feed,this.props.role != 'view'?this.props.design_save_id:undefined,doms,document.getElementById('design_doms_parent'),dont_activate_controller);
            if(!window.design_editor.design.category_id){
                window.design_editor.design.category_id = category_id
            }


            this.props.setDesignLoaded();

            if(input_feed.category_id != category_id){
                this.props.set_default_category(input_feed.category_id)
            }

            // if(this.props.role =='view'){
            //     window.design_editor.init_promise.then(() => {
            //         window.design_editor.draw()
            //         window.design_editor.design.wait_to_load()
            //         .then(() => {
            //             var srcs = []
            //             for (var i = 0; i < window.design_editor.design.pages.length; i++) {
            //                 srcs.push(window.design_editor.design.pages[i].export('low'));
            //             }
            //             window.design_editor = null;
            //             this.props.set_view_display_src(srcs)
            //         })
            //     })
                    
            // }
        }else if(prev_props.pages != this.props.pages){
            //this should run whenever number of pages change
            var doms = []
            for (var i = 0; i < this.props.pages; i++) {
                doms.push(window.document.getElementById('design_preview'+i))
            }

            window.design_editor.updateDoms(doms);
        }
    }

    shouldComponentUpdate(nextProps,nextState){
        var case1 = nextProps.pages != this.props.pages;
        var case2 = this.props.view_display_srcs.length != nextProps.view_display_srcs.length;
        var case3 = this.props.design_save_id != nextProps.design_save_id;
        var case4 = this.props.design_file==null && nextProps.design_file!=null;

        if(case1 || case2 || case3 || case4){
            return true
        }else{
            return false
        }
    }

    render_pages = () => {
        if(this.props.role == 'view'){
            return this.create_design_doms_view()
        }else{
            return this.create_design_doms()
        }
    }

    create_design_doms_view = () => {
        var pages = this.props.pages;
        var result = []
        for (var i = 0; i < pages; i++) {
            tempFunction(i,this)
        }

        function tempFunction(i,this_as_param){
            result.push(
                <center key={i}><div id={"design_preview" + i} style={{paddingTop:'30px'}}></div></center>
            )
        }        
        
        return result
    }

    create_design_doms = () => {
        var pages = this.props.pages;
        var result = []
        for (var i = 0; i < pages; i++) {
            tempFunction(i,this,i==(pages-1))
        }

        function tempFunction(i,this_as_param,last){
            result.push((<Row key={"design_preview_parent_key" + i} id={"design_preview_parent" + i} className='editor_div' style={{paddingTop:"10px",'backgroundColor': '#FFFFFF',marginBottom: (last?'0px':'30px')}}>
                <div id={"design_preview" + i} style={{position:'relative'}}>
                    <Row style={{width: '100%',display:'block',margin:'auto',marginBottom:'5px'}}>
                        <Col className="unselectable" xs={5} style={{textAlign:'left'}}>
                            Page {(i+1)}
                        </Col>
                        <Col className="unselectable" xs={7} style={{position:'relative',zIndex:'1009',textAlign:'right'}}>
                            {pages>1 && (<i onClick={() => this_as_param.movePage(i,"up")} className="fa fa-2x fa-caret-up" style={{color:i==0?"#cccccc":"#222222",height:'20px', verticalAlign:'middle', marginTop: '-20px', padding: 5,cursor:'pointer'}} />)}
                            {pages>1 && (<i onClick={() => this_as_param.movePage(i,"down")} className="fa fa-2x fa-caret-down" style={{color:i==pages-1?"#cccccc":"#222222", marginRight: '5px', height:'20px', verticalAlign:'middle', marginTop: '-20px', padding: 5,cursor:'pointer'}} />)}
                            <Image onClick={() => this_as_param.clonePage(i)} src={global.config.static_file_server_path+'uploads/icons/copy.svg'} style={{marginRight:'10px',height:'20px',cursor:'pointer'}} />
                            {pages>1 && (<Image onClick={() => this_as_param.deletePage(i)} src={global.config.static_file_server_path+'uploads/icons/delete.svg'} style={{height:'20px',cursor:'pointer'}} />)}
                        </Col>
                    </Row>
                </div>
            </Row>))
        }        
        
        return result
    }

    clonePage = (page_index) => {
        this.props.set_pages(this.props.pages+1)
        .then(() => {
            var doms = []
            for (var i = 0; i < this.props.pages; i++) {
                doms.push(window.document.getElementById('design_preview'+i))
            }
            window.design_editor.addNewPage(doms,window.design_editor.design.pages[page_index]);
            
            if(window.document.getElementById('design_preview' + (this.props.pages-1))){
                window.document.getElementById('design_preview' + (this.props.pages-1)).scrollIntoView({behavior: "smooth"})
            }
                
        })
    }

    deletePage = (page_index) => {
        window.design_editor.deletePage(window.design_editor.design.pages[page_index]);
        
        this.props.set_pages(this.props.pages-1)
        .then(() => {
            if(window.document.getElementById('design_preview' + (this.props.pages-1))){
                window.document.getElementById('design_preview' + (this.props.pages-1)).scrollIntoView({behavior: "smooth"})
            }
        })
    }

    movePage = (page_index, direction) => {
        window.design_editor.movePage(page_index, direction);
        var doms = []
        for (var i = 0; i < this.props.pages; i++) {
            doms.push(window.document.getElementById('design_preview'+i))
        }

        window.design_editor.updateDoms(doms);
        if(direction == 'up'){
            if(window.document.getElementById('design_preview' + (page_index-1))){
                window.document.getElementById('design_preview' + (page_index-1)).scrollIntoView({behavior: "smooth"})
            }
        }else if(direction == 'down'){
            if(window.document.getElementById('design_preview' + (page_index+1))){
                window.document.getElementById('design_preview' + (page_index+1)).scrollIntoView({behavior: "smooth"})
            }
        }
    }
    
    render() {
        return (<>{this.render_pages()}</>)
    }
}

export default CanvasPages;